/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { BrandingsStoreRequest, BrandingsStoreResponse } from '../types/BrandingsStore'

/**
 * POST /brandings
 * @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::store
 */
export async function brandingsStore(
	data: BrandingsStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BrandingsStoreResponse>> {
	return axiosInstance.post('/brandings', data, config)
}
